<template>
    <div class="container-fluid">
        <b-tabs v-if="collectionSheet">

            <b-tab
                v-for="(category, index) in collectionSheet.fields"
                :key="category.category.id"
                :id=" 'tab-' + index "
                :label="category.category.name" >

                <div class="table-responsive">
                    <table class="table table-striped">

                        <thead>
                            <tr> <th>Name</th> <th>info</th> <th>Type</th> <th class="min-w-150">Value</th> <th>Unit</th> <th>Clear</th> <th>Code</th> <th>Extra</th> <th>Last updated</th> </tr>
                        </thead>

                        <tbody>
                            <entry-input
                                v-for="(measurement, index) in category.measurements"
                                :key="index"
                                :measurement="measurement">
                            </entry-input>
                        </tbody>
                    </table>
                </div>

            </b-tab>

        </b-tabs>
    </div>
</template>

<script>
import EntryInput from './EntryInput';

export default {
    components : {"entry-input" : EntryInput},

    props : {

        collectionSheet : {
            type : Object,
            default : {},
        }

    },

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/measurements-module/entry/EntryForm.vue